import React from "react";
import { observer } from "mobx-react";
import { CreditAccountUpdateStore } from "../../store";
import { CreditAccountUpdateForm } from "./CreditAccountUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type CreditAccountUpdateProps = {
  creditAccountUpdateStore: CreditAccountUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CreditAccountUpdate: React.FC<CreditAccountUpdateProps> = observer(
  ({ creditAccountUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={creditAccountUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={creditAccountUpdateStore.savedButOutdated}
          onReload={() => creditAccountUpdateStore.reloadCreditAccount()}
          reloadDisabled={creditAccountUpdateStore.isProcessing}
        />
        <CreditAccountUpdateForm
          creditAccountUpdateStore={creditAccountUpdateStore}
          tierError={creditAccountUpdateStore.errors.tier?.message}
          onTierChange={(value) => {
            creditAccountUpdateStore.setTierValue(value);
          }}
          tierSelectedValue={creditAccountUpdateStore.entityValues.showTier}
          onTierSelected={(value) => {
            creditAccountUpdateStore.setSelectedTier(value);
          }}
          tierOptions={creditAccountUpdateStore.getTierOptions()}
          movementsVisibleColumns={
            creditAccountUpdateStore.movementsVisibleColumns
          }
          movementsRows={creditAccountUpdateStore.entityValues.showMovements}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={creditAccountUpdateStore.saveDisabled}
          onSave={() => creditAccountUpdateStore.saveCreditAccount()}
          onCancel={() => creditAccountUpdateStore.cancelCreditAccount()}
        />
        <ErrorDialog
          open={creditAccountUpdateStore.errorDialogOpened}
          title={creditAccountUpdateStore.errorTitle}
          description={creditAccountUpdateStore.errorDescription}
          onClose={() => creditAccountUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={creditAccountUpdateStore.confirmDialogOpened}
          title={creditAccountUpdateStore.confirmDialogTitle}
          description={creditAccountUpdateStore.confirmDialogDescription}
          onConfirm={() => creditAccountUpdateStore.executeConfirmedAction()}
          onCancel={() => creditAccountUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
